<template>
  <div class="comment">
    <transition name="comment">
      <div v-if="!commentVisible" class="comment__text" key="comment-text">
        <span @click="setCommentVisible">Добавить комментарий к заказу</span>
      </div>
      <div v-if="commentVisible" key="commnet-input">
        <div class="t-form__input">
          <textarea v-model="comment"></textarea>
          <label
            class="t-form__input-placeholder"
            :class="{active: comment}"
          >Оставьте свой комментарий</label>
          <span class="t-form__input-error">Некорректные данные</span>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      commentVisible: false,
      comment: ""
    };
  },
  watch: {
    comment() {
      this.$emit("change", this.comment);
    }
  },
  methods: {
    setCommentVisible: function() {
      this.commentVisible = !this.commentVisible;
    }
  }
};
</script>

<style lang="sass" scoped>
.comment
  min-height: 20px
  transition: all .2s
  overflow: hidden
  &__text
    font-size: 18px
    line-height: 20px
    color: #5599DD
    font-weight: 700
    cursor: pointer

  .t-form__input
    max-width: 900px
    textarea
      background-color: transparent

  &-enter-active
    transition: all .3s

  &-leave-active
    position: absolute
    transition: all .2s

  &-enter,
  &-leave-to
    opacity: 0
</style>


// WEBPACK FOOTER //
// src/templates/components/ui/comment.vue